import app from './common/app'
import common from './common/messages'
import roles from './common/roles'
import seo from './seo'
import orderStatus from './order/status'
import orderCourierCard from './order/courierCard'
import orderRestaurantCard from './order/restaurantCard'
import orderAdminCard from './order/adminCard'
import orderClientCard from './order/clientCard'
import finance from './finance/messages'
import restaurantCatalog from './restaurant/catalog'
import auth from './auth/messages'
import deliveryAddress from './delivery-address/messages'
import notificationChannels from './notification-channels/messages'
import referral from './referral/messages'
import payment from './payment/messages'
import cms from './cms/messages'
import home from './views/home'
import search from './views/search'
import dish from './views/dish'
import adminCatalog from './admin/catalog'
import adminRestaurant from './admin/restaurant'
import adminOrders from './admin/orders'
import adminWallets from './admin/wallets'
import adminAccounts from './admin/accounts'
import adminTransactions from './admin/transactions'
import adminOperations from './admin/operations'
import adminUsers from './admin/users'

export default {
  en: {
    app: app.en,
    seo: seo.en,
    auth: auth.en,
    common: common.en,
    deliveryAddress: deliveryAddress.en,
    notificationChannels: notificationChannels.en,
    referral: referral.en,
    payment: payment.en,
    cms: cms.en,
    roles: roles.en,
    order: {
      status: orderStatus.en,
      courierCard: orderCourierCard.en,
      restaurantCard: orderRestaurantCard.en,
      adminCard: orderAdminCard.en,
      clientCard: orderClientCard.en,
    },
    finance: finance.en,
    restaurantCatalog: restaurantCatalog.en,
    adminCatalog,
    adminRestaurant,
    adminOrders,
    adminWallets,
    adminAccounts,
    adminTransactions,
    adminOperations,
    adminUsers,
    views: {
      home: home.en,
      search: search.en,
      dish: dish.en,
    },
  },
  ru: {
    app: app.ru,
    seo: seo.ru,
    auth: auth.ru,
    common: common.ru,
    deliveryAddress: deliveryAddress.ru,
    notificationChannels: notificationChannels.ru,
    referral: referral.ru,
    payment: payment.ru,
    cms: cms.ru,
    roles: roles.ru,
    order: {
      status: orderStatus.ru,
      courierCard: orderCourierCard.ru,
      restaurantCard: orderRestaurantCard.ru,
      adminCard: orderAdminCard.ru,
      clientCard: orderClientCard.ru,
    },
    finance: finance.ru,
    restaurantCatalog: restaurantCatalog.ru,
    adminCatalog,
    adminRestaurant,
    adminOrders,
    adminWallets,
    adminAccounts,
    adminTransactions,
    adminOperations,
    adminUsers,
    views: {
      home: home.ru,
      search: search.ru,
      dish: dish.ru,
    },
  },
}
